$(document).ready(function() {
  $(".header__menu_button").click(function(){
    $(".hamburger, .site__menu").toggleClass("is-active");
  });
  inView('.js-animate')
  .on('enter', el => {
      $(el).addClass("css-animate");
  });
  $(window).scroll(function(){
    if($(window).scrollTop() > 300 ) {
        $(".arrow-top").addClass('active');
    } else {
        $(".arrow-top").removeClass('active');
    }
  });
  $(".message__info").click(function(){
    $(".message__info").css("display", "none");
  });
  $('.content__gallery').magnificPopup({
    delegate: 'a.openPhoto',
    type: 'image',
    tLoading: 'Ładowanie #%curr%...',
    mainClass: 'mfp-with-zoom',
    tClose: 'Zamknij',
    gallery: {
      enabled: true,
      navigateByImgClick: true,
      tPrev: 'Poprzednie',
      tNext: 'Następne',
      preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
      tCounter: '<span class="mfp-counter">%curr% z %total%</span>'
    },
    image: {
      tError: '<a href="%url%">Zdjęcie #%curr%</a> nie może być załadowane.',
      titleSrc: function (item) {
          return item.el.attr('title');
      }
    }
  });
  $(".arrow-top").click(function(){
    $("html, body").animate({ scrollTop: 0 }, "slow");
    return false;
  });
  // $('.banner_wrapper').slick({
  //     prevArrow: $('.banner_prev'),
  //     nextArrow: $('.banner_next'),
  //     autoplay: true,
  //     autoplaySpeed: 3000,
  //     dots: true,
  //     speed: 1500,
  //     cssEase: 'linear',
  //     customPaging : function(slider, i) {
  //       var thumb = $(slider.$slides[i]).data();
  //       return '<button><span>0'+(i+1)+'</span></button>';
  //     },
  // })
  // .on('init', function(event, slick){
	//
  // })
  // .on('beforeChange', function(event, slick, currentSlide, nextSlide){
	//
  // })
  // .on('afterChange', function(event, slick, currentSlide, nextSlide){
  //   $(event.target).find(".banner-item").find(".banner-item-text").removeClass("css-animation");
  //   $(event.target).find(".banner-item.slick-current.slick-active").find(".banner-item-text").addClass("css-animation");
  //   $(".banner__count").html("0" + (currentSlide + 1));
  // });
	$(".banner_wrapper").owlCarousel({
			items:1,
			// animateIn: 'lightSpeedIn',
			// animateIn: 'pulse',
			margin:0,
			stagePadding:0,
			smartSpeed:450,
			autoplay:true,
			nav:true,
			navText : ["",""],
			loop:true,
			// dots:true,
			autoplayTimeout:3000,
			autoplayHoverPause:true,
			onChange: callback,
			});
			function callback(event) {
				$('.text--banner1').hide();
				$('.text--banner2').hide();
				$('.text--banner3').hide();

				$('.text--banner1').addClass('fadeInLeft animated');
				$('.text--banner2').addClass('fadeInRight animated');
				$('.text--banner3').addClass('fadeInUp animated');
				clearTimeout(myVar);
				var myVar = setTimeout(function() {
					$('.owl-item.active').find('.text--banner1').show();
					$('.owl-item.active').find('.text--banner2').show();
					$('.owl-item.active').find('.text--banner3').show();
				}, 1000);
				}
  $(".banner-item.slick-current").find(".banner-item-text").addClass("css-animation");
  $('.banner__page').slick({
      autoplay: true,
      autoplaySpeed: 3000,
      dots: false,
      nav: false,
      fade: true,
      speed: 1500,
      cssEase: 'linear'
  });
  $('.realization__banner').owlCarousel({
			items:1,
			// animateIn: 'lightSpeedIn',
			// animateIn: 'pulse',
			margin:0,
			stagePadding:0,
			smartSpeed:450,
			autoplay:false,
			nav:true,
			navText : ["",""],
			loop:true,
			// dots:true,
			// autoplayTimeout:3000,
			// autoplayHoverPause:true,
			// onChange: callback,
			});
});

var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
$('.video--slider-item').bind('click', function(e) {
    e.preventDefault();
    $('.v-left-area').html('<div id="video--inner" class="video--inner"></div>');
    var player;
    var videoData = $(this).data('videoid');
    player = new YT.Player('video--inner', {
        height: '100%',
        width: '100%',
        videoId: videoData,
        playerVars: {
            showinfo: 0,
            rel: 0
        },
        events: {
            'onReady': function(e) { /* e.target.playVideo(); */ }
        }
    });
});

function onYouTubeIframeAPIReady() {
    if ($('.video--slider-wrap').length > 0) {
        if ($('.video--slider-item').length > 0) {
            $('.video--slider-item').click();
        } else {
            $('.galleryVideo .videoSlider > a:not(.bx-clone)')[0].click();
        }
    }
}
